export const availableIds = [
    'gin:bfa2fe2c-2e1c-48e5-9c25-f9d2d2bb8f71',
    'gt:4629',
] as const;
